import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getTrack } from "../api/getTrack";

class TrackContainer extends React.Component {
  componentDidMount() {
    const { trackId } = this.props;
    this.props.request(trackId);
  }
  componentWillReceiveProps(nextProps) {
    const { trackId: nextTrackId } = nextProps;
    const { trackId } = this.props;
    if (nextTrackId !== trackId) {
      this.props.request(nextTrackId);
    }
  }
  // createTrackComment = track => {
  //   if (typeof track.comment !== "object") {
  //     return { __html: track.comment };
  //   } else {
  //     return track.comment;
  //   }
  // };
  render = () => {
    window.scrollTo(0, 0);
    const { data, loading, failure, render } = this.props;
    const track = (data && data.data) || {};
    // if (track && track.comment) {
    //   track.comment = this.createTrackComment(track);
    // }
    return render({ track, loading, failure });
  };
}

TrackContainer.propTypes = {
  trackId: PropTypes.string.isRequired
};

export default CreateContainer(getTrack, TrackContainer);
